var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"/logo.svg","alt":"SAPBKPP","width":"1185","height":"266"}})
}
var staticRenderFns = []

export { render, staticRenderFns }